import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { INDIVIDUAL_STATUS } from "../../constants";

// Enum-like map for tabs and labels
const TabStates = {
  ACTIVE: { id: "1", label: "Active Member", state: INDIVIDUAL_STATUS.ACTIVE },
  SIGNED_IN: { id: "2", label: "Signed In", state: INDIVIDUAL_STATUS.INACTIVE },
  INVITED: { id: "3", label: "Invited", state: INDIVIDUAL_STATUS.INVITED },
  TERMINATED: { id: "4", label: "Terminated", state: INDIVIDUAL_STATUS.TERMINATED },
};

const NavTabIndividuals = ({ loading, toggleTab, activeTab }) => {
  return (
    <Nav className="nav-tabs-custom ms-0 card-header-tabs border-bottom-0 mb-3" role="tablist">
      {Object.entries(TabStates).map(([key, { id, label, state }], index) => (
        <NavItem key={key} className={index === 2 ? "mx-3" : ""}>
          <NavLink
            href="#"
            onClick={(e) => {
              if (loading) e.preventDefault();
              else toggleTab(id, state);
            }}
            className={classnames(
              {
                active: activeTab === id,
                disabled: loading,
                "fw-semibold": activeTab === id,
              },
              "p-2 text-primary"
            )}
          >
            {label}
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};

export default NavTabIndividuals;